import { useState } from "react";
import { Link } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import AuthLayout from "./AuthPageLayout";
import Label from "../../components/form/Label";
import Input from "../../components/form/input/InputField";
import Button from "../../components/ui/button/Button";
import Alert from "../../components/ui/alert/Alert";
import { useConfig } from "../../context/ConfigContext";
import { esqueciSenha } from "../../api/auth";

export default function EsqueciSenha() {
  const { nomeApp } = useConfig();
  const [email, setEmail] = useState("");
  const [enviando, setEnviando] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setEnviando(true);
    try {
      await esqueciSenha(email);
    } finally {
      // Sempre mostra a mesma confirmação, exista o email ou não — o
      // backend já responde igual dos dois jeitos, é só espelhar aqui.
      setEnviado(true);
      setEnviando(false);
    }
  };

  return (
    <>
      <PageMeta title={`Esqueci minha senha | ${nomeApp}`} description="Recuperação de senha" />
      <AuthLayout>
        <div className="flex flex-col flex-1">
          <div className="flex w-full max-w-md flex-1 flex-col justify-center mx-auto">
            <h1 className="mb-1.5 text-title-sm font-bold text-gray-850 dark:text-white/95">
              Esqueci minha senha
            </h1>
            <p className="mb-6 text-sm font-medium text-gray-500 dark:text-gray-400">
              Digite o email da sua conta — se existir, mandamos um link pra você escolher uma senha nova.
            </p>

            {enviado ? (
              <Alert
                variant="success"
                title="Verifique seu email"
                message="Se esse email tiver uma conta, um link de redefinição chega em instantes. Ele vale por 1 hora."
              />
            ) : (
              <form onSubmit={handleSubmit} className="space-y-6">
                <div>
                  <Label htmlFor="esqueci-email">Email</Label>
                  <Input
                    id="esqueci-email"
                    type="email"
                    placeholder="seuemail@exemplo.com"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                  />
                </div>
                <Button className="w-full" size="sm" disabled={enviando}>
                  {enviando ? "Enviando..." : "Enviar link"}
                </Button>
              </form>
            )}

            <p className="mt-6 text-center text-sm text-gray-500 dark:text-gray-400">
              <Link to="/login" className="text-brand-500 hover:underline dark:text-brand-400">
                Voltar pro login
              </Link>
            </p>
          </div>
        </div>
      </AuthLayout>
    </>
  );
}
